module.exports = __webpack_public_path__ + "static/media/addiction-alcohol-alcoholic-svgrepo-com.901a5690.svg";